import './FormButton.css';
import React from 'react';

interface Props {
  buttonText: string;
  enabled: boolean;
  onButtonPress: () => void;
}

function FormButton({
  buttonText,
  enabled,
  onButtonPress,
}: Props): JSX.Element {
  return (
    <button
      className={`${enabled ? 'FormButtonEnabled' : 'FormButtonDisabled'}`}
      onClick={enabled ? onButtonPress : () => {}}
    >
      {buttonText}
    </button>
  );
}

export default FormButton;
